import { render, staticRenderFns } from "./ThemePage.vue?vue&type=template&id=38bab17f&"
import script from "./ThemePage.vue?vue&type=script&lang=ts&"
export * from "./ThemePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports